exports = module.exports = require("../../../../vue-ssr-factory/node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".page-title[data-v-780011da] {\n  font-size: 16px !important;\n  font-weight: bold !important;\n  white-space: nowrap !important;\n  color: white !important;\n  margin-top: -3px !important;\n  background-image: none !important;\n}\n.c-nav-bm-categories[data-v-780011da] {\n  margin-left: 20px;\n}\n", ""]);

